import React from 'react'
import { array } from 'prop-types'
import styles from './MediumGrid.styl'
import TranslationContext from '../../../utils/TranslationContext'

export default class MediumGrid extends React.Component {

	static propTypes = {
		items: array
	}

	static contextType = TranslationContext

	render() {
		const { items } = this.props
		const { i18n } = this.context
		const sectionBlocks = (items || []).map((service, index) => {
			const { card: { title, summary }, images } = service
			const backgroundImage = images && Array.isArray(images) && images.length ? `url(${ images[0] })` : null

			return (
				<div
					key={ index }
					className={ styles['challenge-container'] }
					style={ { backgroundImage } }
				>
					<div />
					<h3>{ title }</h3>
					<p>{ summary }</p>
				</div>
			)
		})
		return (
			<div>
				<div className={ styles['content'] }>
					<h1>{ i18n`personal_trainer_label` }</h1>
					<div className={ styles['cards-container'] }>
						{ sectionBlocks }
					</div>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/client/website/components/MediumGrid/MediumGrid.js